import axios from 'axios';
export const LOAD_TEST_DATA = 'load_test_data';
export const SET_ACTIVE_TEST = 'set_active_test';
export const SET_ACTIVE_RESULT = 'set_active_result';

export function loadTestData() {
  return (dispatch, getState) => {
    const request = {
      method: 'GET',
      url: `${getState().params.apiURL}/public/clients/${getState().params.clientID}/`,
    };
    return axios(request)
      .then((response) => {
        dispatch({ type: LOAD_TEST_DATA, payload: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function saveClient(client) {
  return (dispatch, getState) => {
    const request = {
      method: 'PUT',
      url: `${getState().params.apiURL}/public/clients/${client.id}/`,
      data: client,
    };
    return axios(request)
      .then(() => {
        dispatch(loadTestData());
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function setActiveTest(name) {
  return (dispatch) => {
    dispatch({ type: SET_ACTIVE_TEST, payload: name });
  };
}

export function saveScore(test, answers) {
  return (dispatch, getState) => {
    const data = {
      name: test,
      answers: answers,
    };
    const request = {
      method: 'POST',
      url: `${getState().params.apiURL}/public/clients/${getState().clientData.testData.id}/test_results/`,
      data: data,
    };
    return axios(request)
      .then((response) => {
        dispatch({ type: SET_ACTIVE_RESULT, payload: response.data });
        dispatch(loadTestData());
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function closeTest() {
  return (dispatch) => {
    dispatch({ type: SET_ACTIVE_TEST, payload: '' });
    dispatch({ type: SET_ACTIVE_RESULT, payload: null });
  };
}



// WEBPACK FOOTER //
// ./src/actions/client.js